const AntenistaIcon = ({ color, height = '32px', width = '32px' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 75 91"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    data-testid="antennist"
  >
    <title>Home_Manager_logo_no_circle_words_rgb</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g
        id="Home_Manager_logo_no_circle_words_rgb"
        transform="translate(1.000000, 0.000000)"
        stroke={color || '#00008F'}
      >
        <path
          d="M68.59,56.57 C68.59,45.32 68.59,28.98 68.59,28.98"
          id="Path"
          strokeWidth="2"
        />
        <path
          d="M10.59,28.98 L10.59,67.57 C10.59,67.57 10.73,67.57 11.01,67.57"
          id="Path"
          strokeWidth="2.0153"
        />
        <path
          d="M6.59,26.36 L6.59,26.36 C6.59,25.38 7,24.72 7.7,24.14 L37.17,1.8 C38.6,0.72 40.57,0.72 42,1.8 L71.48,24.14 C72.1,24.66 72.58,25.3 72.58,26.36 C72.58,28.66 69.94,29.98 68.11,28.58 L40.19,7.42 C39.83,7.15 39.34,7.15 38.98,7.42 L11.06,28.59 C9.22,29.98 6.59,28.67 6.59,26.36 Z"
          id="Path"
          strokeWidth="2"
        />
        <path
          d="M30.59,58.07 C30.59,49.87 30.59,38.98 30.59,38.98 L48.59,38.98 C48.59,38.98 48.59,59.88 48.59,65.57"
          id="Path"
          strokeWidth="2"
        />
        <path
          d="M43.59,23.98 C43.59,26.19 41.8,27.98 39.59,27.98 C37.38,27.98 35.59,26.19 35.59,23.98 C35.59,21.77 37.38,19.9799585 39.59,19.9799585 C41.8,19.97 43.59,21.77 43.59,23.98 Z"
          id="Path"
          strokeWidth="2"
        />
        <path d="M37.59,52.98 L35.59,52.98" id="Path" strokeWidth="2" />
        <g
          id="Group"
          transform="translate(0.000000, 57.000000)"
          strokeWidth="2"
        >
          <path
            d="M30.86,9.59 L40.18,10.89 C40.91,10.99 41.65,11 42.39,10.92 L42.8,10.87 C44.3,10.39 45.44,9.05 45.57,7.39 C45.74,5.19 44.09,3.27 41.89,3.1 L29.05,1.46 C24.58,0.89 20.08,2.32 16.76,5.37 L8.98,12.53 L8.41,12.95"
            id="Path"
          />
          <path
            d="M26.12,20.89 C26.8,20.89 41.7,23.78 41.7,23.78 C43.34,24.09 45.04,23.78 46.47,22.91 L58.26,15.7 L69.8,4.8 C70.65,4 70.76,2.68 70.04,1.75 C68.68,-2.77555756e-17 66.15,-0.31 64.4,1.05 L54.85,8.49 L42.81,10.87"
            id="Path"
          />
          <path
            d="M26.12,20.89 C24.95,20.87 23.8,21.26 22.91,22.02 L19.05,25.3"
            id="Path"
          />
          <path
            d="M7.45,11.81 C6.73,10.97 5.46,10.88 4.62,11.59 L1.21,14.49 C0.37,15.2 0.27,16.46 0.99,17.3 L13.05,31.49 C13.77,32.33 15.03,32.42 15.87,31.71 L19.29,28.81 C20.13,28.1 20.23,26.84 19.51,26 L7.45,11.81 Z"
            id="Path"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default AntenistaIcon;
